import React from "react";

import CarrerList from "../../data/Carrer/index.json";

const Careers = () => {
  let carrerData = CarrerList[0];
  // console.log(carrerData);
  return (
    <>
      {/* <div className="careers-page-wrapper sm-top sm-bottom">
        <div className="container">
          <h2 className="careers-page-title">We are Hiring</h2>
          <p style={{ fontWeight: "bold" }}>
            For further details Email to -{" "}
            <a href="mailto:hr@kangaroocareindia.com">
              hr@kangaroocareindia.com
            </a>{" "}
            or Contact on <a href="tel:9686059747">9686059747</a>
          </p>
          <p></p>
          <p></p>
          <div
            className="service-details-info"
            dangerouslySetInnerHTML={{ __html: carrerData.aboutServiceDesc }}
          />
        
        </div>
      </div> */}

      <section className="carrer_wrapper">
        <div className="carrer_container">
          <h1>Join Our Team</h1>

          <div className="carrer_item">
            <div>
              <p>
                At Kangaroo Care Women and Children Hospital, we are committed
                to building a passionate team of professionals dedicated to
                transforming lives through exceptional care in women’s health,
                child wellness and fertility. We offer a dynamic and supportive
                work environment that encourages growth, continuous learning and
                innovation.
              </p>
              <p>
                Whether you're an experienced specialist or beginning your
                journey in healthcare, you’ll find opportunities to sharpen your
                skills, collaborate with leading experts and make a meaningful
                impact in the lives of women, children and families.
              </p>
              <p>
                Our culture emphasizes teamwork, professional development and
                patient-centered care. By joining Kangaroo Care Women and
                Children Hospital, you become part of a community that values
                compassion, cutting-edge technology and excellence across all
                facets of care. Ready to make a difference? Discover our career
                opportunities and be a part of a mission that nurtures health
                and fulfills dreams.
              </p>
            </div>
            <section class="form_wrapper">
              <form
                method="POST"
                enctype="multipart/form-data"
                action="https://mail.digikit.in/forms/kangaroocare/career/send.php"
                class="form"
              >
                <div>
                  <input type="text" name="name" placeholder="Name" required />
                </div>
                <div>
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    required
                  />
                </div>

                <div>
                  <input
                    type="tel"
                    pattern="^[6-9]\d{9}$"
                    name="phone"
                    placeholder="Your Phone Number"
                    required
                  />
                </div>

                <div>
                  <div className="input_logo">
                    <textarea
                      id="message"
                      name="message"
                      placeholder="Message"
                    ></textarea>
                  </div>
                </div>

                <div>
                  <input
                    type="file"
                    id="myfile"
                    name="myfile"
                    data-max-size="100"
                    accept="application/pdf"
                    required
                  />
                </div>

                <div class="form_button">
                  <input type="submit" value="Submit Form" />
                </div>
              </form>
            </section>
          </div>
        </div>
      </section>
    </>
  );
};

export default Careers;
